import { observable, computed } from "mobx";

class Country {
  /** @property {string} */
  @observable id;

  /** @property {string} */
  @observable title;

  /** @property {bool} */
  @observable stateRequired;

  /** @property {bool} */
  @observable cityRequired;

  /** @property {bool} */
  @observable zipCodeRequired;

  /** @property {string} */
  @observable zipCodeRegex;

  /** @property {string} */
  @observable zipCodeExample;

  /** @property {string} */
  @observable zipCodeErrorMessage;

  /**
   * @property {Object} states state code => state label
   */
  @observable states;

  constructor({
    id = null,
    title = null,
    stateRequired = false,
    cityRequired = false,
    zipCodeRequired = false,
    zipCodeRegex = null,
    zipCodeExample = null,
    zipCodeErrorMessage = null,
    states = {},
  }) {
    this.id = id;
    this.title = title;
    this.stateRequired = stateRequired;
    this.cityRequired = cityRequired;
    this.zipCodeRequired = zipCodeRequired;
    this.zipCodeRegex = zipCodeRegex;
    this.zipCodeExample = zipCodeExample;
    this.zipCodeErrorMessage = zipCodeErrorMessage;
    this.states = states;
  }

  @computed
  get hasStates() {
    return Object.keys(this.states).length > 0;
  }
}

export default Country;
